/**
 * @generated SignedSource<<128a2e60e8576400f3e230cd3b98c171>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type composerQueriesEcommerceSettingsQuery$variables = Record<PropertyKey, never>;
export type composerQueriesEcommerceSettingsQuery$data = {
  readonly currencies: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
  } | null> | null;
  readonly ecommerceSettings: {
    readonly currencyGlobalID: string;
    readonly ecommerceID: number;
    readonly ecommerceName: ECommerce;
    readonly productsApi: string | null;
    readonly remoteUrl: string | null;
  } | null;
};
export type composerQueriesEcommerceSettingsQuery = {
  response: composerQueriesEcommerceSettingsQuery$data;
  variables: composerQueriesEcommerceSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productsApi",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyGlobalID",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Currency",
  "kind": "LinkedField",
  "name": "currencies",
  "plural": true,
  "selections": [
    (v5/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesEcommerceSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      },
      (v6/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "composerQueriesEcommerceSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      },
      (v6/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "b412e816cf381f023627050cbc4c3e40",
    "id": null,
    "metadata": {},
    "name": "composerQueriesEcommerceSettingsQuery",
    "operationKind": "query",
    "text": "query composerQueriesEcommerceSettingsQuery {\n  ecommerceSettings {\n    ecommerceID\n    ecommerceName\n    productsApi\n    remoteUrl\n    currencyGlobalID\n    id\n  }\n  currencies {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "b33fc23761b55dbbae812944dd37f485";

export default node;
